/** @jsxImportSource @emotion/react */
import { switcherRedirect } from './common'
import SwitcherStyle from './IDSSwitcherStyle'

const IDSFilterDropDown = ({
  tenants,
  refContainer,
  query,
  handleInputChange,
  handleKeyChange,
}) => (
  <div ref={refContainer} css={SwitcherStyle.dropDown.dropDownContent}>
    <input
      type="text"
      value={query}
      name="query"
      autoFocus
      onChange={handleInputChange}
      autoComplete="off"
      onKeyDown={handleKeyChange}
      css={SwitcherStyle.input}
      id="filter-input"
    />
    <b css={SwitcherStyle.dropDown.rotatedArrow}></b>
    {tenants?.length === 0 ? (
      <span>No results found</span>
    ) : (
      tenants?.map(({ attributes }, key) => (
        <a key={key} href={switcherRedirect(attributes.subdomain)}>
          {attributes.name}
        </a>
      ))
    )}
  </div>
)

export default IDSFilterDropDown
